import {
    PLAN_CHOOSE_CURRENT_PLAN_LNG,
} from './constants';
  
export function chooseCurrentPlan_lng(modal) {
    return {
      type: PLAN_CHOOSE_CURRENT_PLAN_LNG,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case PLAN_CHOOSE_CURRENT_PLAN_LNG:
        return {
          ...state,
          currentPlan_lng:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/plan/redux/chooseCurrentPlan_lng.js